import { cn } from '@/lib/utils'

/**
 * A skeleton is a promise about SHAPE: it belongs where a region is about to fill with content
 * whose layout it already draws. `as="span"` for one placed inside text, where a div is invalid.
 */
type SkeletonProps = React.HTMLAttributes<HTMLElement> & { as?: 'div' | 'span' }

function Skeleton({ className, as: Comp = 'div', ...props }: SkeletonProps) {
    return <Comp data-slot="skeleton" className={cn('shimmer rounded-md bg-secondary', className)} {...props} />
}

export { Skeleton }
